import { Typography, type SxProps, type Theme } from '@mui/material';
import type { ReactNode } from 'react';

const typographyProps = {
    component: 'div' as const,
    variant: 'body2' as const,
    mt: 0.25,
} as const;

interface AnswerTextProps {
    children: ReactNode;
    sx?: SxProps<Theme>;
}

const AnswerText: React.FC<AnswerTextProps> = ({ children, sx }) => (
    <Typography {...typographyProps} sx={{ wordBreak: 'break-word', ...sx }}>
        {children}
    </Typography>
);

export default AnswerText;
